(function() {

    var elemModal = document.querySelectorAll('[g-modal]'),

        selector = document.querySelectorAll('.g-modal'),
        indexSelector,
        maxSelector,

        elemModalValue,
        elemModalFirstParam,
        elemModalSecondParam,
        indexModal,
        maxModal,

        elemModalTarget = document.querySelectorAll('[g-modal-target]'),
        elemModalTrigger = document.querySelectorAll('[g-modal-trigger]'),
        indexTarget,
        maxTarget,

        body = document.querySelector('body'),

        cookie,
        cookieName = "";


    // If the modal and trigger exist, bind click events on triggers and pass the modal trigger id to the triggerModal Method.
    if ( elemModal && elemModalTarget ) {
        for (indexTarget = 0, maxTarget = elemModalTarget.length; indexTarget < maxTarget; indexTarget++) {
            elemModalTarget[indexTarget].addEventListener('click', function(e) {

                var id = this.getAttribute('g-modal-target');
                e.preventDefault();
                triggerModal(id);
                
            });
            
            if(elemModalTrigger) {
                elemModalTrigger[indexTarget].addEventListener('click', function(e) {
                    var id = this.getAttribute('g-modal-trigger');
                    e.preventDefault();
                    triggerModal(id);
                })
            }
        }

        // If we click on the outside overlay, we close the modal.
        for (indexSelector = 0, maxSelector = selector.length; indexSelector < maxSelector; indexSelector++) {
            var container = selector[indexSelector].querySelector('.g-modal__container');
            container.addEventListener('click', function(e) {

                if ( e.target !== this) {
                    return;
                } else {
                    var id = this.closest('[g-modal]').getAttribute('id');
                    triggerModal(id)
                }
            });
        }

        // Close the modal on ESC key
        document.addEventListener('keyup', function(e) {
            if ( e.keyCode == 27) {
                for (indexSelector = 0, maxSelector = selector.length; indexSelector < maxSelector; indexSelector++) {

                    var el = selector[indexSelector];
                    var id = el.getAttribute('id');

                    if ( body.hasAttribute('g-modal-active')) {
                        body.removeAttribute('g-modal-active')
                    }

                    if ( el.classList.contains('is-active')) {
                        document.querySelector('#' + id).classList.remove('is-active');
                    }
                }
            }
        });

        // If we hover a nav__link ( CUSTOM )
        var elemHover = document.querySelectorAll('.nav__link'),
            elemHoverIndex,
            elemHoverMax,
            isMobile;

        // if  (window.outerWidth > 1024 ) {
        //     isMobile == false;
        //     for (elemHoverIndex = 0, elemHoverMax = elemHover.length; elemHoverIndex < elemHoverMax; elemHoverIndex++) {
        //         elemHover[elemHoverIndex].addEventListener('mouseenter', cookieModal);
        //     }
        // } else {
        //     isMobile == true;
        //     setTimeout(function(){
        //         cookieModal();
        //     }, 10000);
        //     // clearTimeout(timeout);
        // }
    }

    // Check if the g-modal params are set to trigger or not the cookie method
    // if ( elemModal) {
    //     cookieModal();
    // }

    // Trigger or not the modal
    function triggerModal(id) {
        if( body.hasAttribute('g-modal-active') ) {
            body.removeAttribute('g-modal-active');
            document.querySelector('#' + id).classList.remove('is-active');

        } else {
            body.setAttribute('g-modal-active', '');
            document.querySelector('#' + id).classList.add('is-active');
        }
    }

    function cookieModal() {
        for (indexModal = 0, maxModal = elemModal.length; indexModal < maxModal; indexModal++) {

            if (isMobile == false) {
                // remove the mouse enter event listener
                for (elemHoverIndex = 0, elemHoverMax = elemHover.length; elemHoverIndex < elemHoverMax; elemHoverIndex++) {
                    elemHover[elemHoverIndex].removeEventListener('mouseenter', cookieModal);
                }
            }

            /* ------------- PROCESS THE EXPIRE ATTRIBUTE ------------------ */

            // Take the expire value attribute and split it :
            elemModalValue = elemModal[indexModal].getAttribute('g-modal');

            // Take the first param, which is the lifepan in days of the popup
            elemModalFirstParam = elemModalValue.substr(0, elemModalValue.indexOf(' '));

            // Take the second param, which is the the attribute that tells which modal is active on pageload.
            elemModalSecondParam = elemModalValue.substr(elemModalValue.indexOf(' ') + 1);

            /* ------------- END PROCESS THE EXPIRE ATTRIBUTE ------------------ */


            //Assign a name for the cookie. If not, the modal will have a default name.
            // if ( elemModal[indexModal].getAttribute('g-modal-target') ) {
            //     cookieName = elemModal[indexModal].getAttribute('g-modal-target');
            // } else {
            //     cookieName = 'g-modal-cookie';
            // }

            if ( elemModal[indexModal].getAttribute('id') ) {
                cookieName = elemModal[indexModal].getAttribute('id');
            } else {
                cookieName = 'g-modal-cookie';
            }

            // Get the cookie g-modal
            cookie = getCookie(cookieName);


            //Check if the cookie does not exist before going ahead
            if ( !cookie ) {

                // If the filtered value has an active param, display the modal choosen in param, if not
                if ( elemModalSecondParam == 'open' ) {

                    // Add the attribute to the body that kills the scroll
                    body.setAttribute('g-modal-active', '');

                    // Change the state of the popup with active param to visible

                    console.log(elemModal[indexModal].getAttribute('id'));
                    document.getElementById(elemModal[indexModal].getAttribute('id')).classList.add('is-active');

                    // document.getElementById(elemModal[indexModal].getAttribute('g-modal-target')).classList.add('is-active');

                    /* ------------- COOKIE SETTINGS ------------------ */

                    // if the expire value contains nothing or is not a number , the cookie will be 24h by default
                    if ( elemModalFirstParam == 0 || isNaN(elemModalFirstParam) ) {
                        console.log("COOKIE 24h")
                        setCookie(cookieName, true, 1);
                    }
                    // else, get the attribute value in g-modal-expire
                    else {
                        console.log("COOKIE " + elemModalFirstParam)
                        setCookie(cookieName, true, elemModalFirstParam);
                    }

                    /* ------------- COOKIE SETTINGS END ------------------ */
                } else {
                    throw "You must set the open param as an attribute in  g-modal in one of the modal in the page";
                }
            }
        }
    }

    /* ------------------- W3C Functions -------------- */
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    /* ------------------------------------------------ */

}())
